<template>
  <div class="form-container">


      <!-- Nova Questão: Pãp de Leite -->
    <div class="question-group">
      <label class="required">Pão de Leite (50g):</label>
      <div class="checkbox-group">
        <label v-for="(p, index) in paes" :key="index">
              <input 
              type="radio"
              name="pao" 
              v-model="cardapio.pao" 
              :value="p" 
              :onchange="emitirCardapio"/> {{  p }}
        </label>
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Pão selecionado: {{ cardapio.pao }}
    </div>

    <!-- Questão do Suco -->
     <br />
    <div class="question-group">
      <label class="required">Néctar de Frutas - Embalagem Individual 200ml:</label>
      <div class="checkbox-group">
        <label v-for="(suco, index) in sucos" :key="index">
              <input 
                type="radio"
                name="suco" 
                v-model="cardapio.suco" 
                :value="suco" 
                :onchange="emitirCardapio"/> {{ suco }}
        </label>
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Suco(s) selecionado(s): {{ cardapio.suco }}
    </div>

    <!-- Nova Questão: Bolos -->
    <div class="question-group">
      <label class="required">Bolo Embalagem Individual (35g)</label>
      <div class="checkbox-group">
          <label v-for="(bolo, index) in bolos" :key="index">
               <input 
              type="radio"
              name="bolo" 
              v-model="cardapio.bolo" 
              :value="bolo" 
              :onchange="emitirCardapio"/> {{  bolo }}

        </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Bolo selecionado: 
      <span v-if="cardapio.bolo">
        {{ cardapio.bolo }}
      </span>
    </div>

    <!-- Nova Questão: Fruta -->
    <div class="question-group">
      <label class="required">Fruta</label>
      <div class="checkbox-group">
          <label v-for="(fruta, index) in frutas" :key="index">
               <input 
              type="radio"
              name="fruta" 
              v-model="cardapio.fruta" 
              :value="fruta" 
              :onchange="emitirCardapio"/> {{  fruta }}

        </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Fruta selecionada: 
      <span v-if="cardapio.fruta">
        {{ cardapio.fruta }}
      </span>
    </div>

    <!-- Nova Questão: Barra de Cereal -->
    <div class="question-group">
      <label class="required">Barra de Cereal - Embalagem Individual (25g):</label>
      <div class="checkbox-group">
        <label v-for="(barraCereal, index) in barraCereal" :key="index">
              <input 
              type="radio"
              name="barraCereal" 
              v-model="cardapio.barraCereal" 
              :value="barraCereal" 
              :onchange="emitirCardapio"/> {{  barraCereal }}
        </label>
      </div>
    </div>
    <div class="itens-selecionados">
      Barra Cereal: {{ cardapio.barraCereal }}
    </div>

  </div>
</template>

<script>
export default {
  props: {
    tipoCardapio: {
      type: Number,
      default: null
    },
  },
  data() {
    return {

      bolos: [
        'Baunilha com Recheio de Baunilha',
        'Baunilha com Recheio de Chocolate',
        'Chocolate com Recheio de Chocolate',
      ],

      frutas: [
        'Banana Nanica',
        'Maçã',
      ],

      paes: [
        'Presunto, Queijo Muçarela, Alface, Tomate',
        'Peito de Peru, Queijo Muçarela, Alface, Tomate',
      ],

      aguas: [
        'Sim',
        'Não',
      ],

      barraCereal: [
        'Sim',
        'Não',
      ],

      sucos: [
        'Uva',
        'Maracujá',
        'Laranja',
        'Goiaba',
        'Maça',
      ],

      cardapio: {
        tipoCardapio: null,
        pao: '',
        suco: '',
        bolo: '',
        fruta: '',
        barraCereal: '',
      },
    };
  },

  methods: {

    resetCardapio(){

      this.cardapio = {
        tipoCardapio: null,
        pao: '',
        suco: '',
        bolo: '',
        fruta: '',
        barraCereal: '',
      }
    },

    emitirCardapio() {
      this.$emit('atualizar-cardapio', this.cardapio);
    }

  },

  created(){

  },

  mounted() {
    this.resetCardapio();
  },

  computed: {

  }
};
</script>
  
<style src="../css/buffet.css"></style>

